module.exports = __webpack_public_path__ + "assets/media/announcer_ment_information_1.bf68acf9.mp3";